import { render, staticRenderFns } from "./RuralDetail.vue?vue&type=template&id=28453e6c&scoped=true&"
import script from "./RuralDetail.vue?vue&type=script&lang=js&"
export * from "./RuralDetail.vue?vue&type=script&lang=js&"
import style0 from "./RuralDetail.vue?vue&type=style&index=0&id=28453e6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28453e6c",
  null
  
)

export default component.exports